<!--
ModalRegularSending.vue
ロボ定期送付モーダル
caller:
  RoboCard.vue
-->
<template>
  <div>
    <BasicModal
      :title="displayTexts.sending_type + '送付'"
      :isShowModal=isShowModal
      :canCancel="true"
      @cancel="cancel">
      <div class="tab-container">
        <b-tabs type="is-boxed">
          <b-tab-item label="頻度">
            <div class="basic-modal-content">
              <section>
                <p class="sub-title">頻度の登録</p>
                <div class="description">
                  <p>ロボのURLが掲載された{{ displayTexts.sending_type }}を、定期的に自動配信することができます。（午前10時に送付）</p>
                  <p>送付のタイミングを以下から選択し、登録してください。</p>
                </div>
                <div class="buttons-wrapper">
                  <button
                    class="button is-small"
                    :class="{'selected': dateType === 1}"
                    @click="dateType = 1">
                    日
                  </button>
                  <button class="button is-small"
                    :class="{'selected': dateType === 2}"
                    @click="dateType = 2">
                    曜日
                  </button>
                  <button
                    class="button is-small"
                    :class="{'selected': dateType === 3}"
                    @click="dateType = 3">
                    月初・月末
                  </button>
                </div>
                <div class="setting-area">
                  <!-- 日 -->
                  <div class="setting-area-date" v-if="dateType === 1">
                    <span style="padding-right: 16px;">毎月</span>
                    <b-numberinput
                      v-model='date'
                      controls-position="compact"
                      min="1"
                      max="31">
                    </b-numberinput>
                    <span style="padding-left: 16px;">日</span>
                  </div>
                  <!-- 曜日 -->
                  <div class="setting-area-date" v-else-if="dateType === 2">
                    <span style="padding-right: 16px;">毎週</span>
                    <template v-for="(weekdayname, i) in weekdayList">
                      <b-radio
                        v-model='weekday'
                        :key="i"
                        name="week"
                        :native-value="i + 1">
                        {{weekdayname}}
                      </b-radio>
                    </template>
                    <span style="padding-left: 16px;">曜日</span>
                  </div>
                  <!-- 月初・月末 -->
                  <div class="setting-area-date" v-else-if="dateType === 3">
                    <span style="padding-right: 16px;">毎月</span>
                    <template v-for="(particularDate, i) in particularDateList">
                      <b-radio
                        v-model='particular_date'
                        :key="i"
                        name="particular"
                        :native-value="i + 1">
                        {{particularDate}}
                      </b-radio>
                    </template>
                  </div>
                </div>
                <button class="register-button button is-primary is-fullwidth is-small"
                  @click="registerPeriod()"
                  :disabled=duringPeriodRegistration>
                  登録
                </button>
              </section>
              <section class="periods-list">
                <p class="sub-title">登録済みリスト</p>
                <div class="item-period-container disp-scroll">
                  <template v-for="(p, i) in periodList">
                    <div class="item-period-wrapper" :key="i">
                      <p>{{sortPeriod(p)}}</p>
                      <button @click="deleteChatBotRegularSendingPeriod(p.pk)" class="button is-small is-danger">削除</button>
                    </div>
                  </template>
                </div>
              </section>
            </div>
          </b-tab-item>
          <b-tab-item label="宛先">
            <div class="basic-modal-content disp-scroll">
              <section>
                <p class="sub-title">宛先を個別登録</p>
                <p class="desc">定期{{ displayTexts.sending_type }}を送付する{{ displayTexts.address_type }}を入力し、登録してください。</p>
                <div class="input-wrapper">
                  <input class="input is-small" type="email" v-model="address">
                  <button class="button is-small is-primary"
                  @click="registerDest('address')"
                  :disabled=duringDestRegistration>登録</button>
                </div>
              </section>
              <section style="padding-top: 24px;">
                <p class="sub-title">部署ごとに一括登録</p>
                <p class="desc">定期{{ displayTexts.sending_type }}を送付する役職または部署を入力し、登録してください。</p>
                <div class="input-wrapper">
                  <div style="min-width: 40px; font-size: 14px; font-weight: bold; padding-top: 3px;">役職</div>
                  <div style="display: flex; width: 100%;">
                    <select class="select is-small" v-model="selectedPos" style="width: 100%;">
                      <option v-for="(p, idx) in positions" :key="idx" :value="p">
                        {{p.name}}
                      </option>
                    </select>
                  </div>
                  <div style="min-width: 40px; font-size: 14px; font-weight: bold; padding-top: 3px;">部署</div>
                  <div style="display: flex; width: 100%;">
                    <select class="select is-small" v-model="selectedDep" style="width: 100%;">
                      <option v-for="(d, idx) in departments" :key="idx" :value="d">
                        {{d.name}}
                      </option>
                    </select>
                  </div>
                  <button class="button is-small is-primary"
                  @click="registerDest('pos&dep')"
                  :disabled=duringDestRegistration>登録</button>
                </div>
              </section>
              <section style="padding-top: 24px;">
                <div style="display: flex;">
                  <div style="width: 100%;">
                    <p class="sub-title">宛先をリストから登録</p>
                    <p class="desc">リストから定期{{ displayTexts.sending_type }}を送付したいユーザーを選択してください。</p>
                  </div>
                  <div style="font-size: 12px;width:80px;padding-top: 18px;margin-right: 8px;">{{selectedUser.length}}人 選択中</div>
                  <button class="button is-small is-primary"
                  style="margin-top: 12px;"
                  @click="registerUser()"
                  :disabled=duringDestRegistration>登録</button>
                </div>
                <SelectMemberTable
                  ref="userTable"
                  :users = users
                  :usersStatusAPI="usersStatusAPI"
                  @sendMember = "selectDestUser"
                  style="height: 300px;">
                  <template v-slot:username="slotProps" v-if="media_type=='SMS'">
                    <p style="text-align: left">{{ slotProps.user.username }}</p>
                    <p style="font-size: 8px; text-align: left; color: #808080">
                      {{ slotProps.user.phone ? "" : "※電話番号が設定されていません" }}
                    </p>
                  </template>
                </SelectMemberTable>
              </section>
              <section class="dest-list">
                <p class="sub-title">登録済みリスト　※チェックを付けた宛先に送付されます</p>
                <div class="item-list">
                  <div class="item">
                    <article class="dest-list-table">
                      <section class="table-header">
                        <ul>
                          <li class="header-dest">{{ displayTexts.address_type }}</li>
                          <li class="header-robo-sending">
                            <b-checkbox style="margin-top: 2px;" :value="checkedAllAddresses.is_robo_link" @input="bulkChangeRoboLink('address')"></b-checkbox>
                            <span class="header-text">ロボリンク</span>
                          </li>
                          <li class="header-talk-log-sending" v-if="showRoboLogSending">
                            <b-checkbox style="margin-top: 2px;" :value="checkedAllAddresses.is_robo_log" @input="bulkChangeRoboLog('address')"></b-checkbox>
                            <span class="header-text">回答結果</span>
                          </li>
                          <li class=header-delete></li>
                        </ul>
                      </section>
                      <template v-for="(e, i) in destinations.filter(d => d.email || d.phone)">
                        <section class="table-content" :key="'mail-'+i">
                          <ul>
                            <!-- Eメールアドレス -->
                            <li class="dest">{{e.email || e.phone}}</li>
                            <!-- ロボリンク -->
                            <li class="robo-sending">
                              <b-checkbox :value="e.is_robo_link" @input="changeRoboLink(e.pk, $event)"></b-checkbox>
                            </li>
                            <!-- 回答結果 -->
                            <li class="talk-log-sending" v-if="showRoboLogSending">
                              <b-checkbox :value="e.is_robo_log" @input="changeRoboLog(e.pk, $event)"></b-checkbox>
                            </li>
                            <li class="delete-button-wrapper">
                              <button @click="deleteChatBotRegularSending(e.pk)"
                                class="button is-small is-danger">
                                削除
                              </button>
                            </li>
                          </ul>
                        </section>
                      </template>
                      <section class="table-header">
                        <ul>
                          <li class="header-dest-half">役職</li>
                          <li class="header-dest-half">部署</li>
                          <li class="header-robo-sending">
                            <b-checkbox style="margin-top: 2px;" :value="checkedAllDepartments.is_robo_link" @input="bulkChangeRoboLink('pos&dep')"></b-checkbox>
                            <span class="header-text">ロボリンク</span>
                          </li>
                          <li class="header-talk-log-sending" v-if="showRoboLogSending">
                            <b-checkbox style="margin-top: 2px;" :value="checkedAllDepartments.is_robo_log" @input="bulkChangeRoboLog('pos&dep')"></b-checkbox>
                            <span class="header-text">回答結果</span>
                          </li>
                          <li class=header-delete></li>
                        </ul>
                      </section>
                      <template v-for="(e, i) in destinations.filter(d => !d.email && !d.phone && !d.user)">
                        <section class="table-content" :key="'pos&dep-'+i">
                          <ul>
                            <!-- 役職 -->
                            <li :class="['dest-half', 'color-red']" v-if="e.position==null && e.department==null"
                              @click="switchShowUsers(e.pk)">
                              社内ユーザー全体
                            </li>
                            <li :class="['dest-half', {'color-gray': e.position == null}]" v-else
                              @click="switchShowUsers(e.pk)">
                              {{e.position != null ? e.position_name : '(指定なし)'}}
                            </li>
                            <!-- 部署 -->
                            <li :class="['dest-half', {'color-gray': e.department == null}]"
                              @click="switchShowUsers(e.pk)">
                              {{e.department != null ? e.department_name : e.position != null ? '(指定なし)' : ''}}
                            </li>
                            <!-- ロボリンク -->
                            <li class="robo-sending">
                              <b-checkbox :value="e.is_robo_link" @input="changeRoboLink(e.pk, $event)"></b-checkbox>
                            </li>
                            <!-- 回答結果 -->
                            <li class="talk-log-sending" v-if="showRoboLogSending">
                              <b-checkbox :value="e.is_robo_log" @input="changeRoboLog(e.pk, $event)"></b-checkbox>
                            </li>
                            <li class="delete-button-wrapper">
                              <button @click="deleteChatBotRegularSending(e.pk)"
                                class="button is-small is-danger">
                                削除
                              </button>
                            </li>
                          </ul>
                          <div v-if="showUserListPosDep.includes(e.pk)">
                            <div v-for="(u, ui) in usersListIn(e.position,e.department)" :key="ui"
                              style="margin-left: 20px;">
                              {{u.username}}
                            </div>
                          </div>
                        </section>
                      </template>
                      <section class="table-header">
                        <ul>
                          <li class="header-dest">ユーザー</li>
                          <li class="header-robo-sending">
                            <b-checkbox style="margin-top: 2px;" :value="checkedAllUsers.is_robo_link" @input="bulkChangeRoboLink('user')"></b-checkbox>
                            <span class="header-text">ロボリンク</span>
                          </li>
                          <li class="header-talk-log-sending" v-if="showRoboLogSending">
                            <b-checkbox style="margin-top: 2px;" :value="checkedAllUsers.is_robo_log" @input="bulkChangeRoboLog('user')"></b-checkbox>
                            <span class="header-text">回答結果</span>
                          </li>
                          <li class=header-delete></li>
                        </ul>
                      </section>
                      <template v-for="(e, i) in destinations.filter(d => d.user)">
                        <section class="table-content" :key="'user-'+i">
                          <ul>
                            <!-- ユーザー -->
                            <li class="dest">
                              <div>{{e.user_name}}</div>
                              <div style="color:gray; font-size:10px; padding-top: 1px;" v-if="media_type=='Email'">
                                {{e.user_email}}
                              </div>
                              <div style="color:gray; font-size:10px; padding-top: 1px;" v-if="media_type=='SMS'">
                                {{e.user_phone ? "" : "※電話番号が設定されていません"}}
                            </div>
                            </li>
                            <!-- ロボリンク -->
                            <li class="robo-sending">
                              <b-checkbox :value="e.is_robo_link" @input="changeRoboLink(e.pk, $event)"></b-checkbox>
                            </li>
                            <!-- 回答結果 -->
                            <li class="talk-log-sending" v-if="showRoboLogSending">
                              <b-checkbox :value="e.is_robo_log" @input="changeRoboLog(e.pk, $event)"></b-checkbox>
                            </li>
                            <li class="delete-button-wrapper">
                              <button @click="deleteChatBotRegularSending(e.pk)"
                                class="button is-small is-danger"
                                style="margin-top: 6px;">
                                削除
                              </button>
                            </li>
                          </ul>
                        </section>
                      </template>
                    </article>
                  </div>
                </div>
              </section>
            </div>
          </b-tab-item>
          <b-tab-item label="送信内容">
            <div class="basic-modal-content ">
              <section>
                <p class="sub-title">件名</p>
                <div class="input-wrapper">
                  <input maxlength="300" class="input is-small" v-model="title"/>
                </div>
                <p class="sub-title mail-content">本文</p>
                <div class="input-wrapper">
                  <textarea maxlength="1000" class="textarea is-small disp-scroll" v-model="content"></textarea>
                </div>
                <div class="mail-content-desc">
                  <p>ロボリンク送付時の{{ displayTexts.sending_type }}本文です。<br><span style="font-weight: bold">__robo_url__</span>と入力した位置、または本文の下にロボのリンクが挿入されます。</p>
                </div>
                <br/>
                <button class="register-button button is-primary is-fullwidth is-small" @click="modifySendingContent()">
                  変更
                </button>
              </section>
            </div>
          </b-tab-item>
          <b-tab-item label="即時送付">
            <div class="basic-modal-content disp-scroll">
              <section>
                <div style="display:flex;">
                  <p class="sub-title">指定された宛先に一括でロボのURLを送ります。</p>
                </div>
                <p class="sub-title" style="margin-top: 8px;">条件で絞り込み</p>
                <div class="select-condition">
                  <div class="attr">役職</div>
                  <input class="input is-small" style="margin-right:16px;" v-model="selectCondPos"/>
                  <div class="attr">部署</div>
                  <input class="input is-small" v-model="selectCondDep"/>
                </div>
                <SelectMemberTable
                  ref="memberTable"
                  :users = users
                  :narrow = narrow
                  :batchSelect= true
                  :usersStatusAPI="usersStatusAPI"
                  @sendMember = "selectSendMember"
                  style="height: 300px;">
                  <template v-slot:username="slotProps" v-if="media_type=='SMS'">
                    <p style="text-align: left">{{ slotProps.user.username }}</p>
                    <p style="font-size: 8px; text-align: left; color: #808080">
                      {{ slotProps.user.phone ? "" : "※電話番号が設定されていません" }}
                    </p>
                  </template>
                </SelectMemberTable>
                <br>
                <button class="register-button button is-primary is-fullwidth is-small"
                  @click="sendContent()">
                  送付
                </button>
              </section>
            </div>
          </b-tab-item>
        </b-tabs>
      </div>
    </BasicModal>
  </div>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
import SelectMemberTable from '@/components/molecules/tables/SelectMemberTable'

export default {
  components: {
    BasicModal,
    SelectMemberTable
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: false,
    },
    chatbot: {
      type: String,
      required: false,
    },
    media_type: {
      type: String,
      required: true
    },
    users: {
      type: Array,
      required: false
    },
    usersStatusAPI: {
      type: Array,
      required: true
    }
  },
  data () {
    const weekdayList = ['月','火','水','木','金','土','日']
    const particularDateList = ['月初', '月末']
    return {
      weekdayList: weekdayList,
      particularDateList: particularDateList,
      autoScoutSettingSync: {
        isScout: false,
        segment: 0,
        visitedCount: 1,
        spendTime: 30,
        isConv: false
      },
      dateType: 1,
      date: 1,
      weekday: 1,
      particular_date: 1,
      address: '',
      destinations: [],
      periodList: [],
      sendList: [],
      duringPeriodRegistration: false,
      duringDestRegistration: false,
      title: null,
      content: null,
      selectCondPos: '',
      selectCondDep: '',
      selectedPos: {pk: null, name:'(指定なし)'},
      selectedDep: {pk: null, name:'(指定なし)'},
      selectedUser: [],
      showUserListPosDep: []
    }
  },
  computed: {
    displayTexts () {
      /**
       * モーダルの(送信)タイプごとの表示用テキスト
       * @return {Object} result
       * @return {String} result.sending_type - 送信方法を表すテキスト
       * @return {String} result.address_type - 宛先を表すテキスト
       */
      let messages = {}
      if (this.media_type == 'Email') {
        messages.sending_type = 'メール'
        messages.address_type = 'Eメールアドレス'
      }
      else if (this.media_type == 'SMS') {
        messages.sending_type = 'SMS'
        messages.address_type = '電話番号'
      }
      return messages
    },
    departments () {
      let ary = [].concat(...this.users.map(user => user.departments))
      ary = ary.filter((elem, index, self) => self.findIndex(e => e.pk == elem.pk) == index)
      ary.unshift({pk: null, name:'(指定なし)'})
      return ary
    },
    positions () {
      let ary = [].concat(...this.users.map(user => user.positions))
      ary = ary.filter((elem, index, self) => self.findIndex(e => e.pk == elem.pk) == index)
      ary.unshift({pk: null, name:'(指定なし)'})
      return ary
    },
    narrow () {
      //絞り込み
      let condition = (user) => {
        let con1 = this.selectCondPos=='' || user.positions.some(p => p.name.indexOf(this.selectCondPos)==0)
        let con2 = this.selectCondDep=='' || user.departments.some(d => d.name.indexOf(this.selectCondDep)==0)
        return con1 && con2
      }
      return condition
    },
    showRoboLogSending () {
      /**
       * 回答履歴のチェックボックスを表示するかどうか
       * @return {Bool} result
       */
      if (this.media_type == 'Email') return true
      return false
    },
    checkedAllAddresses () {
      /**
       * 個別登録のすべてがチェックされているか
       * @return {Object} result
       * @return {Bool} result.is_robo_link - ロボリンク送付
       * @return {Bool} result.is_robo_log - 回答履歴送付
       */
      let dest = this.destinations.filter((d)=>d.email!=null || d.phone!=null)
      return {
        is_robo_link: dest.every((d)=>d.is_robo_link),
        is_robo_log: dest.every((d)=>d.is_robo_log)
      }
    },
    checkedAllDepartments () {
      /**
       * 役職/部署登録のすべてがチェックされているか
       * @return {Object} result
       * @return {Bool} result.is_robo_link - ロボリンク送付
       * @return {Bool} result.is_robo_log - 回答履歴送付
       */
      let dest = this.destinations.filter((d)=>d.email==null && d.phone==null && d.user==null)
      return {
        is_robo_link: dest.every((d)=>d.is_robo_link),
        is_robo_log: dest.every((d)=>d.is_robo_log)
      }
    },
    checkedAllUsers () {
      /**
       * ユーザー登録のすべてがチェックされているか
       * @return {Object} result
       * @return {Bool} result.is_robo_link - ロボリンク送付
       * @return {Bool} result.is_robo_log - 回答履歴送付
       */
      let dest = this.destinations.filter((d)=>d.user!=null)
      return {
        is_robo_link: dest.every((d)=>d.is_robo_link),
        is_robo_log: dest.every((d)=>d.is_robo_log)
      }
    }
  },
  watch: {
    date () {
      if (this.date > 31) this.date = 31
    }
  },
  mounted() {
    this.fetchChatBotRegularSendingContent()
    this.fetchChatBotRegularSending()
    this.fetchChatBotRegularSendingPeriod()
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
    fetchChatBotRegularSendingContent() {
      /**
       * 送信内容を取得
       */
      this.$store.dispatch("chatbot/getChatbotRegularSendingContent", {
        bot_id: this.chatbot,
        media_type: this.media_type})
        .then((data) => {
          this.title = data.title
          this.content = data.body
        })
    },
    registerPeriod () {
      let data = {
        chatbot: this.chatbot,
        media_type: this.media_type
      }
      if(this.dateType === 1) {
        if (this.duplicatePeriodCheck(this.dateType, this.date)) return
        data.date = this.date
      } else if (this.dateType === 2) {
        if (this.duplicatePeriodCheck(this.dateType, this.weekday)) return
        data.weekday = this.weekday
      } else if (this.dateType === 3) {
        if (this.duplicatePeriodCheck(this.dateType, this.particular_date)) return
        data.particular_date = this.particular_date
      }
      if (this.dateType >= 1) {
        this.duringPeriodRegistration = true
        this.$store.dispatch("chatbot/chatBotRegularSendingPeriod", data)
          .then((data) => {
            this.duringPeriodRegistration = false
            this.fetchChatBotRegularSendingPeriod()
          })
          .catch((e) => {
            this.duringPeriodRegistration = false
          })
      }
    },
    duplicatePeriodCheck (type, inputPeriod) {
      for (const v of Object.values(this.periodList)) {
        if (type === 1) {
          if (v.date === inputPeriod)  {
            alert ('この日程は登録済みです。')
            return true
          }
        } else if (type === 2) {
          if (v.weekday === inputPeriod)  {
            alert ('この日程は登録済みです。')
            return true
          }
        } else if (type === 3) {
          if (v.particular_date === inputPeriod)  {
            alert ('この日程は登録済みです。')
            return true
          }
        }
      }
      return false
    },
    fetchChatBotRegularSendingPeriod () {
      this.$store.dispatch("chatbot/fetchChatBotRegularSendingPeriod", {bot_id:this.chatbot, media_type:this.media_type})
        .then((data) => {
          this.periodList = data
        })
    },
    deleteChatBotRegularSendingPeriod (pk) {
      this.$store.dispatch("chatbot/deleteChatBotRegularSendingPeriod", {bot_id: this.chatbot, pk})
        .then((data) => {
          this.fetchChatBotRegularSendingPeriod()
        })
    },
    registerUser () {
      let num = this.selectedUser.length
      if (num==0) {
        alert('ユーザーが選択されていません')
        return
      }
      let dupl = 0
      for (const u of this.selectedUser) {
        if (this.registerDest('user', u.user_hash) == -1) dupl+=1
      }
      alert((num-dupl)+'人を登録しました ('+dupl+'人は登録済みです)')
      this.$refs.userTable.allCancel()
    },
    registerDest (cls, target) {
      let data = {
        chatbot: this.chatbot,
        is_robo_link: true,
        is_robo_log: false,
        media_type: this.media_type
      }
      if (cls == "address") {
        if (this.media_type == 'Email') {
          data.email = this.address
          if (this.duplicateDestCheck(data, cls) || this.emailFormatCheck(this.address)) return
        }
        else if (this.media_type == 'SMS') {
          data.phone = this.trimPhoneNumber(this.address)
          if (this.duplicateDestCheck(data, cls) || this.phoneFormatCheck(this.address)) return
        }
      }
      else if (cls == "pos&dep") {
        data.position = this.selectedPos.pk
        data.department = this.selectedDep.pk
        if (this.duplicateDestCheck(data, cls)) return
      }
      else if (cls == 'user') {
        data.user = target
        if (this.duplicateDestCheck(data, cls)) return -1
      }
      else return
      this.duringDestRegistration = true
      this.$store.dispatch("chatbot/chatBotRegularSending", data)
        .then(() => {
          this.duringDestRegistration = false
          this.fetchChatBotRegularSending()
          this.address = ''
          this.selectedPos = {pk: null, name:'(指定なし)'}
          this.selectedDep = {pk: null, name:'(指定なし)'}
          if (cls == "address" || cls == "pos&dep") {
            alert('登録しました')
          }
        })
        .catch(() => {
          this.duringDestRegistration = false
        })
    },
    duplicateDestCheck (data, cls) {
      for (const v of this.destinations) {
        if (cls == 'address' && this.media_type == 'Email' && v.email != null && data.email == v.email) {
          alert('この宛先は登録済みです')
          return true
        }
        if (cls == 'address' && this.media_type == 'SMS' && v.phone != null && data.phone == v.phone) {
          alert('この宛先は登録済みです')
          return true
        }
        if (cls == 'pos&dep' && v.email == null && v.phone == null && v.user == null && data.position == v.position && data.department == v.department) {
          alert('この宛先は登録済みです')
          return true
        }
        if (cls == 'user' && v.user != null && data.user == v.user) {
          return true
        }
      }
      return false
    },
    emailFormatCheck (email) {
      const regexp = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/
      if (!email) {
        alert('入力内容が不正もしくは、入力内容がございません。')
        return true
      } else if (!regexp.test(email)) {
        alert('Eメールアドレスの形式が間違っています。\n内容の修正をお願いいたします。')
        return true
      }
      return false
    },
    trimPhoneNumber (phone) {
      /**
       * 数字以外を削除(ハイフンなど)
       * @param {String} phone - 電話番号
       * @return {String} result - 数字のみ抽出した文字列
       */
      return phone.replace(/[^0-9]+/g, '')
    },
    phoneFormatCheck (phone) {
      /**
       * 電話番号の形式チェック
       * @param {String} phone - 電話番号
       * @return {Bool} result - 形式が正しいかどうか
       */
      phone = this.trimPhoneNumber(phone)
      if (phone.length == 10 || phone.length == 11) {
        return false
      }
      else {
        alert('電話番号の形式が間違っています。')
        return true
      }
    },
    fetchChatBotRegularSending () {
      this.$store.dispatch("chatbot/fetchChatBotRegularSending", {bot_id:this.chatbot, media_type:this.media_type})
        .then((data) => {
          this.destinations = data
        })
    },
    deleteChatBotRegularSending (pk) {
      this.$store.dispatch("chatbot/deleteChatBotRegularSending", {bot_id: this.chatbot, pk})
        .then(() => {
          this.fetchChatBotRegularSending()
        })
    },
    sortPeriod (p) {
      if (p.date) {
        return p.date + '日'
      } else if (p.weekday) {
        return (this.weekdayList[p.weekday - 1]) + '曜日'
      } else if (p.particular_date) {
        return (this.particularDateList[p.particular_date - 1]) 
      }
    },
    modifySendingContent () {
      this.$store.dispatch('chatbot/setChatbotRegularSendingContent', {
        chatbot: this.chatbot,
        media_type: this.media_type,
        title: this.title,
        body: this.content
      })
      .then(() => {
        alert('変更しました。')
      })
    },
    sendContent () {
      const sendList = this.sendList.map((list) => {
        return (this.media_type=='Email' ? list.email : list.phone)
      })
      const userNameList = this.sendList.map((list) => {
        return list.username
      })
      this.$store.dispatch('chatbot/sendEmailContent', {
        bot_id: this.chatbot,
        mail_title: this.title ? this.title : null,
        mail_content: this.content ? this.content : null,
        send_list: sendList,
        send_name_list: userNameList,
        media_type: this.media_type
      })
      .then((d) => {
        const media = (this.media_type == 'Email' ? 'メール' : 'メッセージ')
        alert(media + 'を送付いたしました。')
      })
      .catch((e) => {
        const media = (this.media_type == 'Email' ? 'メール' : 'メッセージ')
        alert(media + '送付時にエラーが発生いたしました。正しく届いていない' + media + 'がございますので宛先をご確認お願いいたします。')
      })
    },
    changeRoboLink (pk, e) {
      const data = {is_robo_link: e}
      this.$store.dispatch("chatbot/updateChatBotRegularSending", {bot_id: this.chatbot, pk, data})
        .then(() => {
          this.fetchChatBotRegularSending()
        })
    },
    changeRoboLog (pk, e) {
      const data = {is_robo_log: e}
      this.$store.dispatch("chatbot/updateChatBotRegularSending", {bot_id: this.chatbot, pk, data})
        .then(() => {
          this.fetchChatBotRegularSending()
        })
    },
    bulkChangeRoboLink (cls) {
      /**
       * ロボURLの送付有無のチェックボックスを一括変更
       * @param {String} cls - 登録クラス 'address' or 'pos&dep' or 'user'
       */
      let dest = []
      let data = []
      if (cls == 'address') {
        dest = this.destinations.filter((d)=>d.email!=null || d.phone!=null)
        data = {is_robo_link: !this.checkedAllAddresses.is_robo_link}
      }
      else if (cls == 'pos&dep') {
        dest = this.destinations.filter((d)=>d.email==null && d.phone==null && d.user==null)
        data = {is_robo_link: !this.checkedAllDepartments.is_robo_link}
      }
      else if (cls == 'user') {
        dest = this.destinations.filter((d)=>d.user!=null)
        data = {is_robo_link: !this.checkedAllUsers.is_robo_link}
      }
      else return
      let promises = []
      for (let d of dest) {
        d.is_robo_link = data.is_robo_link
        let p = this.$store.dispatch("chatbot/updateChatBotRegularSending", {bot_id: this.chatbot, pk: d.pk, data: data})
        promises.push(p)
      }
      Promise.all(promises).then(()=>{this.fetchChatBotRegularSending()})
    },
    bulkChangeRoboLog (cls) {
      /**
       * 回答履歴の送付有無のチェックボックスを一括変更
       * @param {String} cls - 登録クラス 'address' or 'pos&dep' or 'user'
       */
      let dest = []
      let data = []
      if (cls == 'address') {
        dest = this.destinations.filter((d)=>d.email!=null || d.phone!=null)
        data = {is_robo_log: !this.checkedAllAddresses.is_robo_log}
      }
      else if (cls == 'pos&dep') {
        dest = this.destinations.filter((d)=>d.email==null && d.phone==null && d.user==null)
        data = {is_robo_log: !this.checkedAllDepartments.is_robo_log}
      }
      else if (cls == 'user') {
        dest = this.destinations.filter((d)=>d.user!=null)
        data = {is_robo_log: !this.checkedAllUsers.is_robo_log}
      }
      else return
      let promises = []
      for (let d of dest) {
        d.is_robo_log = data.is_robo_log
        let p = this.$store.dispatch("chatbot/updateChatBotRegularSending", {bot_id: this.chatbot, pk: d.pk, data: data})
        promises.push(p)
      }
      Promise.all(promises).then(()=>{this.fetchChatBotRegularSending()})
    },
    selectSendMember(us) {
      this.sendList = us
    },
    selectDestUser(us) {
      this.selectedUser = us
    },
    usersListIn(pos, dep) {
      if (pos == null && dep == null) return this.users
      if (pos == null) return this.users.filter(u => u.departments.map(p=>p.pk).includes(dep))
      if (dep == null) return this.users.filter(u => u.positions.map(p=>p.pk).includes(pos))
      return this.users.filter(u => u.departments.map(p=>p.pk).includes(dep) && u.positions.map(p=>p.pk).includes(pos))
    },
    switchShowUsers(pk) {
      // ログイン不可ユーザーも表示する
      if (this.showUserListPosDep.includes(pk)) this.showUserListPosDep=this.showUserListPosDep.filter(u=>u!==pk)
      else this.showUserListPosDep.push(pk)
    },
  },
}
</script>

<style lang="scss" scoped>
.tab-container {
  padding: 8px;
}
.basic-modal-content {
  padding: 8px;
  height: 480px;
  text-align: center;
  .description {
    text-align: left;
    p {
      font-size: 12px;
    }
  }
  .buttons-wrapper {
    margin-top: 24px;
    .selected {
      background: rgb(221, 221, 221);
    }
  }
  .setting-area {
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    &-date {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .setting-area-date {
    span {
      margin-left: 4px;
    }
  }
  .desc {
    text-align: left;
    font-size: 12px;
    margin-bottom: 4px;
  }
  .input-wrapper {
    display: flex;
    button {
      margin-left: 4px;
    }
  }
  .sendlist-wrapper {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-top: 8px;
  }
  .sub-title {
    text-align: left;
    font-size: 14px;
    margin-bottom: 8px;
    font-weight: bold;
  }
  .dest-list {
    text-align: left;
    padding-top: 24px;
    .item-list {
      padding-right: 8px;
    }
    .item {
      button {
        margin-left: 4px;
      }
    }
    :not(:first-child).item {
      margin-top: 8px;
    }
    .dest-list-table {
      font-size: 12px;
      position: relative;
      .table-header {
        position: sticky;
        top: 0;
        margin-bottom: 8px;
        background: #ffffff;
        z-index: 10;
        ul {
          display: flex;
          align-items: center;
          border: 1px solid gray;
        }
      }
      .table-content {
        margin-bottom: 8px;
        ul {
          display: flex;
        }
      }
    }
    $dest-width: 320px;
    $checkbox-width: 100px;
    .dest {
      width: $dest-width;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 4px;
    }
    .dest-half {
      cursor: pointer;
      width: calc(#{$dest-width} / 2);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 4px;
    }
    .color-gray {
      color: silver;
    }
    .color-red {
      color: red;
    }
    $cell-padding: 4px;
    .header-dest {
      width: $dest-width;
      padding: 4px;
    }
    .header-dest-half {
      width: calc(#{$dest-width} / 2);
      padding: 4px;
    }
    .header-robo-sending {
      width: $checkbox-width;
      padding: $cell-padding;
    }
    .header-talk-log-sending {
      width: $checkbox-width;
      padding: $cell-padding;
    }
    .header-text {
      margin-left: -10px;
      transform: translateY(-2px);
      display: inline-block;
    }
    .header-delete {
      width: 120px;
    }
    .robo-sending, .talk-log-sending {
      display: flex;
      justify-content: center;
      align-items: center;
      width: $checkbox-width - $cell-padding;
      font-size: 16px;
      padding: $cell-padding;
      padding-left: 16px;
    }
    .delete-button-wrapper {
      margin-left: 40px;
    }
  }
  .periods-list {
    margin-top: 24px;
  }
  .item-period-container {
    height: 160px;
    padding-right: 8px;
  }
  .item-period-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px 0;
    p {
      font-size: 12px;
      text-align: left;
      width: 200px;
    }
  }
  :not(:last-child).item-period-wrapper {
    border-bottom: 1px solid #dbdbdb;
  }
  .mail-content {
    margin-top: 24px;
  }
  .mail-content-desc {
    margin-top: 8px;
    text-align: left;
    p {
      font-size: 12px;
    }
  }
  .date-list {
    li {
      text-align: left;
      width: 100%;
      padding: 4px;
      border: 1px solid gray;
    }
    :not(:first-child) {
      border-top: none;
    }
  }
  .nothing-email-message {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.select-condition {
  display: flex;
  width: 100%;
  margin-bottom: 8px;

  .attr {
    min-width: 40px;
    font-size: 14px;
    padding-top: 5px;
  }
}
.table-wrapper {
  display: flex;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components2/Robo/modal/ModalRegularSending.vue